import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = ["aria-describedby", "aria-invalid", "id"]
const _hoisted_3 = ["aria-describedby", "aria-invalid", "id"]
const _hoisted_4 = { class: "rd-mt-1 rd-inline-flex form-radio-group" }
const _hoisted_5 = {
  key: 1,
  class: "input-container"
}
const _hoisted_6 = ["id", "aria-describedby", "aria-invalid"]
const _hoisted_7 = {
  key: 2,
  class: "input-container"
}
const _hoisted_8 = { class: "input-container" }
const _hoisted_9 = { class: "form-row md:rd-gap-x-4" }
const _hoisted_10 = ["aria-describedby", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidatedInput = _resolveComponent("ValidatedInput")!
  const _component_VueRadioButton = _resolveComponent("VueRadioButton")!
  const _component_AddressContainer = _resolveComponent("AddressContainer")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["acknowledgee-input-container", _ctx.isModalDisplay ? 'rd-mt-3' : 'rd-mt-6'])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["rd-flex rd-font-bold", _ctx.isModalDisplay ? 'rd-mb-2.5' : 'rd-mb-4'])
    }, _toDisplayString(_ctx.component.customData.acknowledgeeInformationLabel), 3),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["form-row", { 'md:rd-gap-x-4': _ctx.fieldStyle != _ctx.FieldStyle.Compact }])
      }, [
        _createVNode(_component_ValidatedInput, {
          id: _ctx.component.id,
          value: _ctx.renderStore.tribute.acknowledgeeFirstName,
          label: "First Name",
          class: "rd-w-full md:rd-flex-equal",
          name: "acknowledgeeFirstName",
          isRequired: _ctx.component.customData.hasAcknowledgement,
          maxLength: 75
        }, {
          input: _withCtx((inputProps) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.renderStore.tribute.acknowledgeeFirstName) = $event)),
              placeholder: "First Name",
              "aria-describedby": inputProps.describedBy,
              "aria-required": "true",
              "aria-invalid": inputProps.isInvalid,
              id: _ctx.component.id + '_acknowledgeeFirstName'
            }, null, 8, _hoisted_2), [
              [_vModelText, _ctx.renderStore.tribute.acknowledgeeFirstName]
            ])
          ]),
          _: 1
        }, 8, ["id", "value", "isRequired"]),
        _createVNode(_component_ValidatedInput, {
          id: _ctx.component.id,
          value: _ctx.renderStore.tribute.acknowledgeeLastName,
          label: "Last Name",
          class: "rd-w-full md:rd-flex-equal",
          name: "acknowledgeeLastName",
          isRequired: _ctx.component.customData.hasAcknowledgement,
          maxLength: 75
        }, {
          input: _withCtx((inputProps) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.renderStore.tribute.acknowledgeeLastName) = $event)),
              placeholder: "Last Name",
              "aria-describedby": inputProps.describedBy,
              "aria-required": "true",
              "aria-invalid": inputProps.isInvalid,
              id: _ctx.component.id + '_acknowledgeeLastName'
            }, null, 8, _hoisted_3), [
              [_vModelText, _ctx.renderStore.tribute.acknowledgeeLastName]
            ])
          ]),
          _: 1
        }, 8, ["id", "value", "isRequired"])
      ], 2)
    ]),
    (_ctx.hasBothAcknowledgementMethods)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(["input-container", [{ '!rd-mt-4': _ctx.isModalDisplay }, { 'rd-mb-2': _ctx.acknowledgementMethod === _ctx.AcknowledgementMethod.Postal && _ctx.isModalDisplay }, {}]])
        }, [
          _createElementVNode("fieldset", _hoisted_4, [
            _createElementVNode("legend", {
              class: _normalizeClass(["rd-block rd-text-sm rd-font-medium rd-leading-none", _ctx.isModalDisplay ? 'rd-mb-2.5' : 'rd-mb-4'])
            }, "How would you like your acknowledgement to be sent? ", 2),
            _createVNode(_component_VueRadioButton, {
              id: "Email",
              selected: _ctx.acknowledgementMethod === _ctx.AcknowledgementMethod.Email,
              value: _ctx.AcknowledgementMethod.Email,
              name: "Email",
              modelValue: _ctx.acknowledgementMethod,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.acknowledgementMethod) = $event)),
              labelText: "Email",
              "is-admin": false
            }, null, 8, ["selected", "value", "modelValue"]),
            _createVNode(_component_VueRadioButton, {
              id: "Postal",
              selected: _ctx.acknowledgementMethod === _ctx.AcknowledgementMethod.Postal,
              value: _ctx.AcknowledgementMethod.Postal,
              class: "rd-leading-none rd-ml-5",
              name: "Postal",
              modelValue: _ctx.acknowledgementMethod,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.acknowledgementMethod) = $event)),
              labelText: "Postal",
              "is-admin": false
            }, null, 8, ["selected", "value", "modelValue"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.acknowledgementMethod === _ctx.AcknowledgementMethod.Email)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-row", { 'md:rd-gap-x-4': _ctx.fieldStyle != _ctx.FieldStyle.Compact }])
          }, [
            _createVNode(_component_ValidatedInput, {
              id: _ctx.component.id,
              value: _ctx.renderStore.tribute.acknowledgeeEmailAddress,
              label: "Email Address",
              name: "tributeAcknowledgeeEmailAddress",
              class: "rd-w-full md:rd-flex-equal",
              isRequired: _ctx.component.customData.hasAcknowledgement && _ctx.acknowledgementMethod === _ctx.AcknowledgementMethod.Email,
              isEmail: true
            }, {
              input: _withCtx((inputProps) => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: _ctx.component.id + '_tributeAcknowledgeeEmailAddress',
                  placeholder: "Email Address",
                  "aria-describedby": inputProps.describedBy,
                  "aria-required": "true",
                  "aria-invalid": inputProps.isInvalid,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.renderStore.tribute.acknowledgeeEmailAddress) = $event))
                }, null, 8, _hoisted_6), [
                  [_vModelText, _ctx.renderStore.tribute.acknowledgeeEmailAddress]
                ])
              ]),
              _: 1
            }, 8, ["id", "value", "isRequired"])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.acknowledgementMethod === _ctx.AcknowledgementMethod.Postal)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-row", { 'md:rd-gap-x-4': _ctx.fieldStyle != _ctx.FieldStyle.Compact }])
          }, [
            _createVNode(_component_AddressContainer, {
              id: _ctx.component.id + '_acknowledgeeAddress',
              passedAddress: _ctx.renderStore.tribute.acknowledgeeAddress,
              required: _ctx.component.customData.hasAcknowledgement && _ctx.acknowledgementMethod === _ctx.AcknowledgementMethod.Postal,
              name: "Acknowledgee Address",
              address1Label: "Acknowledgee Address",
              address1Placeholder: "Address Line 1",
              address2Placeholder: "Address Line 2",
              cityPlaceholder: "City",
              statePlaceholder: "State",
              postalPlaceholder: "Postal Code",
              countryPlaceholder: "Country",
              onUpdateAddress: _ctx.updateAddress
            }, null, 8, ["id", "passedAddress", "required", "onUpdateAddress"])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_ValidatedInput, {
          id: _ctx.component.id,
          value: _ctx.renderStore.tribute.message,
          class: "rd-w-full",
          label: "Message to Recipient",
          name: "Tribute.Message",
          isRequired: false
        }, {
          input: _withCtx((inputProps) => [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.renderStore.tribute.message) = $event)),
              placeholder: "Message",
              "aria-describedby": inputProps.describedBy,
              id: _ctx.component.id + '_tributeMessage',
              resize: "none",
              rows: "4"
            }, null, 8, _hoisted_10), [
              [_vModelText, _ctx.renderStore.tribute.message]
            ])
          ]),
          _: 1
        }, 8, ["id", "value"])
      ])
    ])
  ], 2))
}